import { render, staticRenderFns } from "./DicTagButtonUpdate.vue?vue&type=template&id=715d3581&scoped=true&"
import script from "./DicTagButtonUpdate.vue?vue&type=script&lang=js&"
export * from "./DicTagButtonUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DicTagButtonUpdate.vue?vue&type=style&index=0&id=715d3581&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d3581",
  null
  
)

export default component.exports